import { alias } from '@ember/object/computed';

import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
});

export const settings = {
  saveHooks: {
    after: [saveHasManyRelationships('externalReferences')],
  },
  variantProperties: [
    'cmsLanguageId',
    'cmsState',
    'name',
    'seoTitle',
    'seoDescription',
    'seoImage',
    'text',
  ],
};

export default class LabelModel extends Model.extend(Validations) {
  @attr('string') name;
  @attr('string') text;

  // CMS fields
  @attr('string') seoTitle;
  @attr('string') seoDescription;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('asset', { async: true, inverse: null }) asset;
  @hasMany('channel', { async: true, inverse: null }) channels;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @hasMany('external-reference', { async: true, inverse: 'label' })
  externalReferences;

  // Getter, setter and computed properties
  @alias('name') displayHeadline;
  @alias('name') displayLabel;
}
